

























































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import courseList, { CourseListParams } from "@/getinfo-api/course";
import { CoursesList as ICoursesList } from "@/api/models/courses-list";
import { Course as ICourse } from "@/api/models/course";
import { uniqBy } from "lodash";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import {
  currentUserIsCompanyOwner,
  getCurrentUserId,
  isRoot
} from "@/plugins/roles";

@Component
export default class LectureCourseSelect extends Vue {
  @Prop() companyId!: string;
  search!: string | undefined;
  showSpinner: boolean = false;
  selectedCourses!: Array<ICourse>;
  courses: Array<ICourse> = [];
  courseCount: number = 0;
  limit: number = 30;
  offset: number = 0;
  courseLecturesList!: number | undefined;

  data() {
    return {
      selectedCourses: [],
      search: undefined,
      courseCount: undefined,
      courseLecturesList: undefined
    };
  }

  get disabledButton() {
    return this.courseCount > this.courses.length;
  }

  get filteredCourses() {
    return this.courses.filter(el => !this.selectedCourses.includes(el));
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return currentUserIsCompanyOwner();
  }

  get userId() {
    return getCurrentUserId();
  }

  deleteCourse(course: ICourse) {
    this.selectedCourses = this.selectedCourses.filter(element => {
      return element != course;
    });
  }

  showMore() {
    this.offset += this.limit;
    this.getCoursesList(this.offset);
  }

  addCourse(course: ICourse) {
    this.selectedCourses.push(course);
    this.selectedCourses = uniqBy(this.selectedCourses, "id");
  }

  getCoursesList(offset: number | undefined = 0) {
    this.showSpinner = true;
    if (this.companyId) {
      const selectCompanyId: CourseListParams = {
        title: this.search ? this.search : undefined,
        sort: "createdAt",
        order: "DESC",
        companyIds: [this.companyId],
        ownerIds: this.root || this.companyOwner ? undefined : [this.userId],
        offset: offset,
        limit: this.limit
      };
      courseList(selectCompanyId)
        .then((res: { data: ICoursesList }) => {
          this.courseCount = res.data.count;
          res.data.courses.forEach(course => {
            this.courses.push(course);
          });
          this.courses = uniqBy(this.courses, "id");
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.showSpinner = false;
        });
    }
  }

  mounted() {
    if (this.companyId) {
      this.getCoursesList();
    }
  }

  @Watch("selectedCourses")
  selectCourses() {
    let courseIds: Array<string> = [];
    this.selectedCourses.forEach(course => {
      courseIds.push(course.id);
    });
    this.$emit("select", courseIds);
  }

  @Watch("companyId")
  updateCompany() {
    this.getCoursesList();
    this.courses = [];
    this.offset = 0;
  }

  @Watch("search")
  updateCourse() {
    this.courses = [];
    this.offset = 0;
    this.getCoursesList();
  }
}
